import React, { useState, useEffect } from 'react';
import Header from '../../component/dashboard/header';
import {Row, Col} from 'antd';
import { useHistory } from 'react-router-dom';
import { useDispatch,useSelector } from 'react-redux';
import { sethometab } from '../../redux/actions/dashboardActions';
import { HomeOutlined,UnorderedListOutlined,ProfileOutlined} from '@ant-design/icons';
import Lib from '../library/library';
import Coll from './allcollection';
import './dashboardStyles.css';
import 'antd-mobile/dist/antd-mobile.css';
import { organization } from '../../api/api';
import { YM_LOGIN_URL } from '../../api/content-novareader';
import Dashboard from './dashboard';
import { BiArrowBack } from 'react-icons/bi';


const Home = (props) => {
    const history = useHistory();
    const [loading, setloading] = useState(false);
    const dispatch = useDispatch();
    const state = useSelector((state) => state.App);
    const configFile = process.env.REACT_APP_ENV
    const showuser = useSelector((state) => state.App.showlogin);
    const activeTab = props.match.params.type
    console.log(activeTab);
   
    useEffect(() => {
        window.scrollTo(0, 0)
        if(configFile=="lpp"){
        const lpp_userCredentials = JSON.parse(localStorage.getItem('lpp_userCredentials'));
        if (lpp_userCredentials) {
            getSubscription();

        }else{
            getSubscriptionno();

        }
    }
   
    if (activeTab==undefined) {
        sethometab("lib");
    }
       
    }, [])
    const getSubscription = async () => {
        setloading(true)
        const lpp_userCredentials = JSON.parse(localStorage.getItem('lpp_userCredentials'));

        let axios = require('axios');
        let config = {
            method: 'get',
            url: organization,
            headers: {
                'apikey': lpp_userCredentials.apikey
            }
        };
        axios(config)
            .then((response) => {
                if(response.data.data.length==0){
                    setloading(false)

                }else{
                    history.replace('./institutions')
                }
            })
            .catch(function (error) {
                setloading(false)
            });
    }

    const getSubscriptionno = async () => {
        setloading(true)

        let axios = require('axios');
        let config = {
            method: 'get',
            url: organization,
           
        };
        axios(config)
            .then((response) => {
                console.log("organization",response.data.data.length)
                if(response.data.data.length==0){
                    setloading(false)

                }else{
                    history.replace('./institutions')

    
                }
           
            })
            .catch(function (error) {
                setloading(false)


            });
    }
    const login = () => {
        history.replace('/login');
    }
    


const sethome = () => dispatch(sethometab("home"))
const setlib = () =>{
    const lpp_userCredentials = JSON.parse(localStorage.getItem('lpp_userCredentials'));
    if (lpp_userCredentials != null) {
        if (lpp_userCredentials.emailVerified != 1) {
            window.location.href = YM_LOGIN_URL;
        } else {    
            dispatch(sethometab("lib"))
        }
    } else {
        window.location.href = YM_LOGIN_URL;
    }
}
const setdow = () => dispatch(sethometab("coll"))
const setInt = () => dispatch(sethometab("int"))


return (
        <div className="dashboard">
        <Row style={{ "padding": "0px", "margin": "0px 0px 0px 0px" }}>
            <Col xs={{ span: 24, offset: 0 }} lg={{ span: 20, offset: 2 }}>
                 
                {state.hometab=="home"?
                        <Header /> 
                        : null}
                         {state.hometab=="lib"?
                        
        <div className="headerbar">
        <div onClick={() => sethome()}  className="gobackicon">
        <BiArrowBack  className='backicon-page'/>
        </div>
        <div className="bartitel">
            <span className="pageheadertitel" style={{display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}>{props.titel}</span>
        </div>
    </div>
                        : null}
                          {state.hometab=="coll"?
                        <Header /> 
                        : null}
                {state.hometab=="home"?
                        <Dashboard />
                        : null}
                         {state.hometab=="lib"?
                        <Lib/>
                        : null}
                          {state.hometab=="coll"?
                        <Coll/>
                        : null}
                        
               </Col>
        </Row>
       <div className="tabbarrcontiner">
               <div className="tabbarr" >
                    <div className="tabbar_itemm" onClick={() => setlib()} style={{  color: state.hometab=="lib" ? "#ffffff" : "#000",backgroundColor:state.hometab=="lib" ? "#B11116" : "#D6D6D6", }}><ProfileOutlined style={{fontSize:"15px"}} />Library</div>
                    {configFile=="lpp"?<div className="tabbar_itemm" onClick={() => setdow()} style={{ color: state.hometab=="coll" ? "#ffffff" : "#000" ,backgroundColor:state.hometab=="coll" ? "#B11116" : "#D6D6D6",}}><UnorderedListOutlined  style={{fontSize:"15px"}} />Collections</div>:null}

                </div>
                </div>
      </div>)
}

export default Home;